import React, { Component } from 'react';
import ChangePassword from './changePassword';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as AccontAction from '../accountActions';

class ChangePasswordForm extends Component {

	handleSubmit(values) {
		const { accountActions } = this.props;
		accountActions.onChangePassword({ password: values.password, newPassword: values.newPassword, confirmPassword: values.confirmPassword });
	  }
	

	render() {
		const { isLoading } = this.props;
		return (<ChangePassword onSubmit={this.onSubmit}
			isLoading={isLoading}
			handleSubmitBtn={(values) => this.handleSubmit(values)}
        />
		);
	}
}


const mapStateToProps = ({ userAccount }) => {
	const { isLoading } = userAccount;
	return {
	  isLoading,
	};
  };
  


const mapDispatchToProps = (dispatch) => {
	return {
		accountActions: bindActionCreators(AccontAction, dispatch),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ChangePasswordForm));